import React from 'react'
import {clearConfirmNotification} from 'redux/actions'
import {connect} from "react-redux";
import Confirm from "./Confirm";

function HookConfirmPopup(
    {
        confirmNotification,
        clearConfirmNotification
    }) {


    const onCancel = () => {
        if (confirmNotification && confirmNotification.onCancel)
            confirmNotification.onCancel();
        clearConfirmNotification();
    }

    const onConfirm = () => {
        if (confirmNotification && confirmNotification.onConfirm)
            confirmNotification.onConfirm();
        clearConfirmNotification();
    }


    return !!confirmNotification && <Confirm
        open
        onCancel={onCancel}
        onConfirm={onConfirm}
        confirmText={confirmNotification.confirmText}
        confirmText2={confirmNotification.confirmText2}
        labelConfirm={confirmNotification.labelConfirm}
        labelCancel={confirmNotification.labelCancel}
        translateConfirmTexts={confirmNotification.translateConfirmTexts}
    />
}

export default connect((state) => ({
    confirmNotification: state.store.confirmNotification
}), {
    clearConfirmNotification
})(HookConfirmPopup);